const API = {
  API_BASE_URL: 'https://api.pluralonline.com',
  API_AUTH_URL: 'https://api.pluralonline.com',
  SETTLEMENT_API_BASE_URL: 'https://api.pluralonline.com',
  SETTLEMENT_API_AUTH_URL: 'https://api.pluralonline.com',
  API_PAYOUTS_URL: 'https://api.pluralonline.com',
  API_WEBHOOK_KEY: 'g/c14H5a1mTRodU3Itu/kw==',
};

export default {
  API,
};
